export enum TwoPanelType {
    LeftMaxRightFr,
    LeftFrRightMax,
}
